import IntersectionObserver from './IntersectionObserver'
import { gsap } from 'gsap'

class Loading {
  constructor(el) {
    this.dom = {el: el};

    this.init();
  }

  init() {
    const domLoading = this.dom.el;

    // URLにハッシュタグがある場合はローディングをスキップ
    const hasHash = window.location.hash;
    const domLoadingHero = document.querySelector('[data-js="hero"]');
    
    if (!hasHash) {
      if (domLoading) {
        document.body.dataset.isScrolldisable = true;
        const domLoadingLogo = document.querySelector('[data-js="loading-logo"]');
        const domLoadingIllust = document.querySelector('[data-js="loading-illust"]');
        // domLoadingLogo.dataset.loaded = true;
        // domLoadingIllust.dataset.loaded = true;
        // domLoading.dataset.loaded = true;
        setTimeout(() => {
          window.scrollTo(0, 0);
          domLoadingHero.style.opacity = 1;
        }, 300);
        gsap.to(domLoading, {
          opacity: 0,
          duration: .8,
          delay: 1.2,
          onComplete: () => {
            document.body.dataset.loaded = true;
            document.body.removeAttribute('data-is-scrolldisable');
            domLoading.remove();
          }
        })
      }
      else {
        setTimeout(() => {
          document.body.dataset.loaded = true;
          document.body.removeAttribute('data-is-scrolldisable');
        }, 1200);
      }
    } else {
      // ハッシュタグがある場合は即座にローディングを完了
      document.body.dataset.loaded = true;
      if (domLoading) {
        domLoadingHero.style.opacity = 1;
        domLoading.remove();
      }
    }

    // IntersectionObserverを初期化
    setTimeout(() => {
      const domIntersectionObserver = document.querySelectorAll('[data-io]');
      if (domIntersectionObserver) new IntersectionObserver(domIntersectionObserver);
    }, 300)
	}
}

export default Loading